import { render, staticRenderFns } from "./newbadgeframe.vue?vue&type=template&id=69372f05&"
import script from "./newbadgeframe.vue?vue&type=script&lang=js&"
export * from "./newbadgeframe.vue?vue&type=script&lang=js&"
import style0 from "./newbadgeframe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports